module.exports = __webpack_public_path__ + "img/programme_icon_daogou@3x.24025c11.png";